export default "__VITE_ASSET__3b813d28__"